import React, { useEffect, useState } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import { Button, EButtonType, KitIcons, parseToApiDate, SpinnerV2 } from '@repo/apg-ui';
import { getParameterByName } from '../../../utils/toSearchParams';
import './ProductDetail.scss';
import { defined } from '../../../utils/variableEvaluation';
import { useNavigate } from 'react-router';
import { parseISO } from 'date-fns';
import { Product, productsActions } from '../../../store/products';
import { AppState } from '../../../store';
import { ReactComponent as RedXIcon } from '../../../assets/icons/RedX.svg';
import { Modal } from 'react-bootstrap';
import { Loading, UiActions } from '../../../store/ui';
import MapContainer from '../../MapContainer';
import { ProductContextStandard } from '../../../store/products/types';

interface Props {
  loading: Loading;
  location: any;
  productsByUrn: any;
  productsActions: typeof productsActions;
  possibleBookingDates: any;
  uiActions: typeof UiActions;
  basket: any;
  addToBasket?: (product: Product, producturn: string) => void;
  removeFromBasket?: (basketEntryId: string, producturn: string) => void;
}

const ProductDetailModal = ({
  location,
  productsByUrn,
  possibleBookingDates,
  productsActions,
  uiActions,
  loading,
  addToBasket,
  removeFromBasket,
}: Props) => {
  const [product, setProduct] = useState<Product>(null);
  const [showMap, setShowMap] = useState<boolean>(false);
  const [imageLoading, setImageLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const intl = useIntl();
  // const isMobile = useMedia('(max-width: 768px)');

  useEffect(() => {
    const _urn = getParameterByName('urn', location.search);
    if (_urn) {
      if (Object.keys(productsByUrn).includes(_urn)) {
        setProduct(productsByUrn[_urn]);
      } else {
        let startRangeDate;
        if (possibleBookingDates) {
          if (possibleBookingDates && possibleBookingDates['start']) {
            startRangeDate = parseISO(possibleBookingDates['start'].date);
          }
        } else {
          startRangeDate = new Date();
        }

        uiActions.setLoading('productDetails', true);

        productsActions
          .fetchProductByUrn(encodeURI(_urn), parseToApiDate(startRangeDate))
          .then((res) => {
            uiActions.setLoading('productDetails', false);
            setProduct(res.data);
          })
          .catch((error) => {
            uiActions.setLoading('productDetails', false);
          });
      }
    }
  }, [location]);

  const closeModal = () => {
    setProduct({});
    uiActions.setLoading('productDetails', false);
    navigate({ search: '' });
  };

  // const getProductState = () => {
  //     return defined(productsByUrn[product?.producturn]?.state)
  //         ? productsByUrn[product?.producturn]?.state
  //         : product?.state;
  // };

  const getProductSpotLength = () => {
    const spotLength = product?.context_standard?.spothlengths || 10;

    return !!spotLength
      ? `${spotLength} ${intl.formatMessage({
          id: 'ec.general.seconds',
          defaultMessage: 'Sekunden',
        })}`
      : '';
  };

  const getProductLoopLength = () => {
    const frequency = product?.context_standard?.frequency;

    return !!frequency
      ? `${intl.formatMessage({
          id: 'ec.general.all2',
          defaultMessage: 'Alle',
        })} ${frequency} ${intl.formatMessage({
          id: 'ec.general.minutes',
          defaultMessage: 'Minuten',
        })}`
      : '';
  };

  const getOperatingHours = () => {
    const { timeslot, timeslotinformation } = product?.context_standard || {};

    if (timeslot && timeslotinformation) {
      const timeslotInfo = timeslotinformation.find((ts) => ts.timeslot === timeslot);
      return timeslotInfo ? timeslotInfo.timespan : '';
    }

    return '';
  };

  // const productState = getProductState();
  const productContextStandard: ProductContextStandard = product?.context_standard;
  return (
    <div
      className={classNames('productDetailModal', {
        'has-modal-spinner': loading.productDetails,
      })}
    >
      {loading.productDetails && <SpinnerV2 />}
      <Modal.Header className='border-bottom d-flex justify-content-between align-items-start h-auto'>
        <Modal.Title className='d-flex flex-column justify-content-center gap-2'>
          <div className='product-name'>{product?.name}</div>

          <div className='d-flex justify-content-between align-items-center w-100'>
            <div className='d-flex justify-content-start align-items-center'>
              {product?.productid && (
                <div className='product-id'>
                  <div className='product-code'>
                    <span>ID: {product?.productid}</span>
                  </div>
                </div>
              )}

              {/*{productState >= 0 && (*/}
              {/*    <div className="product-state">*/}
              {/*        <div className="d-flex align-items-center">*/}
              {/*            {productState === 0 && (*/}
              {/*                <div className="d-flex justify-content-start ms-4 availability">*/}
              {/*                    <span className="green-checker ps-0">*/}
              {/*                        <KitIcons.GreenCheckV2Icon/>*/}
              {/*                    </span>*/}
              {/*                    <span className="ps-0 font-14 font-600">*/}
              {/*                        {intl.formatMessage({*/}
              {/*                            id: "ec.journey02.available",*/}
              {/*                            defaultMessage:*/}
              {/*                                "Verfügbar",*/}
              {/*                        })}*/}
              {/*                    </span>*/}
              {/*                </div>*/}
              {/*            )}*/}
              {/*            {productState > 0 && (*/}
              {/*                <div className="d-flex justify-content-start ms-4 availability">*/}
              {/*                    <span className="unavailable-checker ps-0">*/}
              {/*                        <KitIcons.CloseRedIcon/>*/}
              {/*                    </span>*/}

              {/*                    <span className="ps-0 font-14 font-600">*/}
              {/*                        {intl.formatMessage({*/}
              {/*                            id: "ec.journey02.unavailable",*/}
              {/*                            defaultMessage:*/}
              {/*                                "Nicht verfügbar",*/}
              {/*                        })}*/}
              {/*                    </span>*/}
              {/*                </div>*/}
              {/*            )}*/}
              {/*        </div>*/}
              {/*    </div>*/}
              {/*)}*/}
            </div>

            <div className='switch-wrapper'>
              <div className='d-flex justify-content-start align-items-center'>
                <div className='d-flex align-items-center justify-content-start font-14'>
                  <span
                    className={classNames('cursor-pointer', {
                      'text-red text-decoration-underline': !showMap,
                    })}
                    onClick={() => {
                      setImageLoading(true);
                      setShowMap(false);
                    }}
                  >
                    <FormattedMessage id='ec.general.photo' defaultMessage='Foto' />
                  </span>
                  <span className='px-3'>|</span>
                  <span
                    className={classNames('cursor-pointer', {
                      'text-red text-decoration-underline': showMap,
                    })}
                    onClick={() => setShowMap(true)}
                  >
                    <FormattedMessage id='ec.general.map' defaultMessage='Karte' />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className='close-modal align-items-start justify-content-start'>
            <Button onClick={closeModal} className='mt-0'>
              <RedXIcon />
            </Button>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={classNames('background-light-grey custom-modal-body')}>
        <div className='modal-body-content'>
          {showMap ? (
            product?.latitude &&
            product?.longitude && (
              <div className='mapContainer p-0'>
                <MapContainer
                  isProductDetailModal={true}
                  center={{
                    lat: product.latitude,
                    lng: product.longitude,
                  }}
                  zoom={15}
                  locations={{
                    [product?.producturn]: product,
                  }}
                  addToBasket={addToBasket}
                  removeFromBasket={removeFromBasket}
                />
              </div>
            )
          ) : (
            <div
              className={classNames('product-image-wrapper', {
                'image-loading': imageLoading,
              })}
            >
              {imageLoading && (
                <div className='image-loader'>
                  <SpinnerV2 relative />
                </div>
              )}
              {product?.productphotopath && (
                <img
                  alt='Product'
                  src={product?.productphotopath + '&resolution=preview'}
                  onLoad={() => {
                    setImageLoading(false);
                  }}
                  loading='lazy'
                />
              )}
            </div>
          )}

          <div className='col d-flex align-items-start justify-content-start product-details p-0'>
            <div className='col d-flex flex-column align-items-start font-14 p-0'>
              <div className='item-label'>
                <FormattedMessage id='ec.general.advertisingMedia' defaultMessage='Produktart' />
              </div>
              {product?.subformat && <div className='item-value'>{product?.subformat}</div>}
            </div>
            <div className='col d-flex flex-column align-items-start font-14 p-0'>
              <div className='item-label'>
                <FormattedMessage id='ec.general.format' defaultMessage='Format' />
              </div>
              {product?.format && <div className='item-value'>{product?.format}</div>}
            </div>
            <div className='col d-flex flex-column align-items-start font-14 p-0'>
              <div className='item-label'>
                <FormattedMessage id='ec.general.bookingUnit' defaultMessage='Buchungseinheit' />
              </div>
              {product?.timeslotsinformation && (
                <div className='item-value'>
                  <FormattedMessage id='ec.general.atLeast' defaultMessage='Mindestens' /> {product?.mindays}{' '}
                  {product?.mindays > 1 ? (
                    <FormattedMessage id='ec.general.days' defaultMessage='Tage' />
                  ) : (
                    <FormattedMessage id='ec.general.day' defaultMessage='Tag' />
                  )}
                </div>
              )}
            </div>

            <div className='col d-flex flex-column align-items-start font-14 p-0'>
              <div className='item-label'>
                <FormattedMessage id='ec.general.content' defaultMessage='Betriebszeit' />
              </div>
              {product?.timeslot && product?.timeslotsinformation && (
                <div className='item-value'>{getOperatingHours()}</div>
              )}
            </div>
          </div>

          <div className='col d-flex align-items-start justify-content-start product-details p-0'>
            <div className='col d-flex flex-column align-items-start font-14 p-0'>
              <div className='item-label'>
                <FormattedMessage id='ec.general.loop' defaultMessage='Loop' />
              </div>
              {productContextStandard?.frequency && <div className='item-value'>{getProductLoopLength()}</div>}
            </div>
            <div className='col d-flex flex-column align-items-start font-14 p-0'>
              <div className='item-label'>
                <FormattedMessage id='ec.general.spotLength' defaultMessage='Spotlänge' />
              </div>
              {productContextStandard?.spothlengths && <div className='item-value'>{getProductSpotLength()}</div>}
            </div>
            <div className='col d-flex flex-column align-items-start font-14 p-0'>
              <div className='item-label'>
                <FormattedMessage id='ec.general.broadcasts' defaultMessage='Ausstrahlungen' />
              </div>
              <div className='item-value'>
                {productContextStandard?.totaltransmission}{' '}
                <FormattedMessage id='ec.general.perWeek' defaultMessage='pro Woche' />
              </div>
            </div>
            <div className='col d-flex flex-column align-items-start font-14 p-0'>
              <div className='item-label'>
                <FormattedMessage id='ec.general.animation' defaultMessage='Animation' />
              </div>
              {product?.name && <div className='item-value'>{product?.additionalinfo?.animation}</div>}
            </div>
          </div>
          <div className='col d-flex align-items-start justify-content-start product-details p-0'>
            <div className='col d-flex flex-column align-items-start font-14 p-0'>
              <div className='item-label'>
                <FormattedMessage id='ec.general.restrictions' defaultMessage='Restriktionen' />
              </div>
              <div className='item-value'>{product?.additionalinfo?.restriction?.branchenlabels?.join(', ')}</div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className='border-top d-flex w-100 bg-white flex-column'>
        <div className={classNames('d-flex align-items-center w-100 justify-content-end')}>
          <Button buttonType={EButtonType.InvertedPillMedium} className='mt-0 ' onClick={closeModal}>
            <FormattedMessage id='ec.components.buttons.close' defaultMessage='Schliessen' />
          </Button>
        </div>
      </Modal.Footer>
    </div>
  );
};

function mapStateToProps(state: AppState, ownProps: any) {
  return {
    ...ownProps,
    ...state.router,
    ...state.ui,
    ...state.products,
    location: state.router.location,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    productsActions: bindActionCreators(productsActions as any, dispatch),
    uiActions: bindActionCreators(UiActions as any, dispatch),
    dispatch: dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailModal);
